import rawData from '../data/data.json';

// `incident_date` is stored as an Excel/Google Sheets serial date number
// (days since the 1899-12-30 epoch). Convert it to a real Date so a
// calendar month can be derived. (Spot-checked: serial 39773 -> 2008-11-21,
// which matches the incident's `notes`/`source` fields.)
const EXCEL_EPOCH_MS = Date.UTC(1899, 11, 30);
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function excelSerialToDate(serial) {
  return new Date(EXCEL_EPOCH_MS + (serial * MS_PER_DAY));
}

// Short form doubles as the join/data key; full form is the row label on
// desktop, where horizontal bars leave room for it. Mobile gets a shorter
// form so labels don't get cut off at narrow widths: months spell out in
// full at four characters or fewer (May, June, July), otherwise three
// letters plus a period (Jan., Feb., ... Dec.); weekdays are always a
// plain three-letter abbreviation.
export const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const MONTH_FULL_LABELS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const MONTH_MOBILE_LABELS = [
  'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June',
  'July', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.',
];

export const WEEKDAY_LABELS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const WEEKDAY_MOBILE_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// gray: not sports-related at all (main_sports, football, homecoming all false)
// orange: other sports-related (main_sports true, football/homecoming false)
// brown: football and/or homecoming
function categorize(d) {
  if (d.football || d.homecoming) return 'brown';
  if (d.type === 'basketball game') return 'orange';
  return 'gray';
}

// function categorize(d) {
//   if (d.football || d.homecoming) return 'brown';
//   if (d.main_sports) return 'orange';
//   return 'gray';
// }

export const records = rawData.map((d) => {
  const date = excelSerialToDate(d.incident_date);
  return {
    ...d,
    date,
    month: date.getUTCMonth(), // 0 = Jan ... 11 = Dec
    category: categorize(d),
  };
});

function buildBucket(label, axisLabel, axisLabelMobile, rows) {
  const bucket = {
    label, axisLabel, axisLabelMobile, gray: 0, brown: 0, orange: 0, total: rows.length,
  };
  rows.forEach((r) => {
    bucket[r.category] += 1;
  });
  return bucket;
}

export function aggregateByMonth() {
  return MONTH_LABELS.map((label, i) => buildBucket(
    label, MONTH_FULL_LABELS[i], MONTH_MOBILE_LABELS[i], records.filter(r => r.month === i),
  ));
}

export function aggregateByWeekday() {
  return WEEKDAY_LABELS.map((label, i) => buildBucket(
    label, label, WEEKDAY_MOBILE_LABELS[i], records.filter(r => r.day_of_week === label),
  ));
}
